<div class="feedback-card">
  <div class="grid-container">
    <div class="grid-item">
      <div class="grid-item-header">
        <div class="grid-item-header_icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none">
            <path
              d="M19.5 3H18.5V1H16.5V3H8.5V1H6.5V3H5.5C4.4 3 3.5 3.9 3.5 5V19C3.5 19.5304 3.71071 20.0391 4.08579 20.4142C4.46086 20.7893 4.96957 21 5.5 21H19.5C20.61 21 21.5 20.11 21.5 19V5C21.5 4.46957 21.2893 3.96086 20.9142 3.58579C20.5391 3.21071 20.0304 3 19.5 3ZM19.5 19H5.5V9H19.5V19ZM5.5 7V5H19.5V7H5.5ZM11.06 17.46L17 11.53L15.93 10.47L11.06 15.34L8.95 13.23L7.89 14.29L11.06 17.46Z"
              fill="#01377C" />
          </svg>
        </div>
        Situation
      </div>
      <div class="content">
        {{ sbi.reported_at | date: 'dd/MM/yyyy' }} - {{ sbi.situation }}
      </div>
    </div>

    <div
      class="grid-item"
      [ngStyle]="!showSuggestion ? { 'grid-row': 'span 2' } : {}">
      <div class="grid-item-header">
        <div class="grid-item-header_icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none">
            <path
              d="M13.9533 1.51565L12.2609 10.4073L18.3918 10.4279L10.0466 22.4819L11.7389 12.6996L5.60843 12.6783L13.9533 1.51565ZM13.9544 0.0156719C13.9139 0.0156719 13.8734 0.0171484 13.8337 0.020125C13.5689 0.0415234 13.3934 0.130023 13.1853 0.269898C13.0681 0.348024 12.9625 0.44219 12.8714 0.549648C12.8441 0.581907 12.8183 0.615445 12.7942 0.650149L4.3893 11.7738C4.05743 12.2286 4.00868 12.829 4.26368 13.3308C4.5183 13.8325 5.03318 14.1505 5.59755 14.1547L9.9273 14.1862L8.56605 22.2063C8.43668 22.8955 8.80418 23.5826 9.45105 23.8593C9.63904 23.9401 9.84154 23.9817 10.0462 23.9815C10.5175 23.9815 10.9049 23.761 11.1956 23.3628L19.6109 11.3088C19.9428 10.8539 19.9912 10.2528 19.7365 9.75175C19.4819 9.25 18.967 8.93198 18.4027 8.92788L14.0729 8.92038L15.4196 1.8685C15.4481 1.75305 15.4624 1.63455 15.4623 1.51563C15.4623 0.704125 14.8162 0.042625 14.0077 0.016375C13.9897 0.015625 13.9721 0.015625 13.9544 0.015625L13.9544 0.0156719Z"
              fill="#01377C" />
          </svg>
        </div>
        Impact
      </div>
      <div class="content">
        {{ sbi.impact }}
      </div>
    </div>

    <div class="grid-item">
      <div class="grid-item-header">
        <div class="grid-item-header_icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none">
            <path
              d="M13.5033 3C17.3833 3 20.5033 6.14 20.5033 10C20.5033 12.8 18.8733 15.19 16.5033 16.31V21H9.50334V18H8.50334C7.39334 18 6.50334 17.11 6.50334 16V13H5.00334C4.58334 13 4.34334 12.5 4.58334 12.19L6.50334 9.66C6.59144 7.86329 7.36756 6.16939 8.67081 4.92945C9.97406 3.6895 11.7045 2.99861 13.5033 3ZM13.5033 1C8.91334 1 5.11334 4.42 4.56334 8.9L3.00334 11H2.97334L2.95334 11.03C2.40334 11.79 2.33334 12.79 2.76334 13.62C3.12334 14.31 3.76334 14.79 4.50334 14.94V16C4.50334 17.85 5.78334 19.42 7.50334 19.87V23H18.5033V17.5C21.0033 15.83 22.5033 13.06 22.5033 10C22.5033 5.03 18.4633 1 13.5033 1ZM17.8333 9.3L15.8733 9.81L17.3133 11.27C17.6633 11.61 17.6633 12.19 17.3133 12.54C16.9633 12.89 16.3833 12.89 16.0433 12.54L14.5933 11.1L14.0733 13.06C13.9533 13.55 13.4633 13.82 13.0033 13.7C12.8869 13.6708 12.7774 13.6189 12.6811 13.5472C12.5848 13.4756 12.5037 13.3855 12.4423 13.2824C12.381 13.1792 12.3406 13.0649 12.3237 12.9461C12.3067 12.8272 12.3134 12.7062 12.3433 12.59L12.8733 10.63L10.9133 11.16C10.7971 11.19 10.6761 11.1967 10.5573 11.1797C10.4384 11.1627 10.3241 11.1224 10.221 11.061C10.1178 10.9997 10.0278 10.9185 9.95611 10.8222C9.88443 10.7259 9.83251 10.6164 9.80334 10.5C9.68334 10.05 9.96334 9.55 10.4433 9.43L12.4033 8.91L10.9633 7.46C10.8129 7.28817 10.7334 7.06558 10.741 6.83732C10.7485 6.60907 10.8426 6.39222 11.0041 6.23073C11.1656 6.06925 11.3824 5.97519 11.6107 5.96762C11.8389 5.96006 12.0615 6.03956 12.2333 6.19L13.6933 7.63L14.2033 5.67C14.3233 5.18 14.8233 4.9 15.2933 5.03C15.7833 5.16 16.0633 5.65 15.9333 6.13L15.4033 8.1L17.3733 7.57C17.8533 7.44 18.3433 7.72 18.4733 8.21C18.6033 8.68 18.3233 9.18 17.8333 9.3Z"
              fill="#01377C" />
          </svg>
        </div>
        Behavior
      </div>
      <div class="content">
        {{ sbi.behaviour }}
      </div>
    </div>

    <div class="grid-item" *ngIf="showSuggestion">
      <div class="grid-item-header">
        <div class="grid-item-header_icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none">
            <path
              d="M8.24964 18H15.7496V19.5H8.24964V18ZM9.74964 21H14.2496V22.5H9.74964V21ZM11.9996 1.5C10.0105 1.5 8.10286 2.29018 6.69634 3.6967C5.28981 5.10322 4.49964 7.01088 4.49964 9C4.44892 10.09 4.65772 11.1765 5.10886 12.17C5.56 13.1636 6.24059 14.0358 7.09464 14.715C7.84464 15.4125 8.24964 15.81 8.24964 16.5H9.74964C9.74964 15.12 8.91714 14.3475 8.10714 13.605C7.40616 13.0682 6.84749 12.3677 6.48007 11.5649C6.11266 10.7621 5.94769 9.88138 5.99964 9C5.99964 7.4087 6.63178 5.88258 7.757 4.75736C8.88222 3.63214 10.4083 3 11.9996 3C13.5909 3 15.1171 3.63214 16.2423 4.75736C17.3675 5.88258 17.9996 7.4087 17.9996 9C18.0507 9.88203 17.8846 10.7631 17.5159 11.566C17.1471 12.3689 16.587 13.069 15.8846 13.605C15.0821 14.355 14.2496 15.105 14.2496 16.5H15.7496C15.7496 15.81 16.1471 15.4125 16.9046 14.7075C17.7581 14.0295 18.4384 13.1585 18.8895 12.1663C19.3407 11.174 19.5498 10.0888 19.4996 9C19.4996 8.01509 19.3056 7.03982 18.9287 6.12987C18.5518 5.21993 17.9994 4.39314 17.3029 3.6967C16.6065 3.00026 15.7797 2.44781 14.8698 2.0709C13.9598 1.69399 12.9846 1.5 11.9996 1.5Z"
              fill="#01377C" />
          </svg>
        </div>
        Suggestion
      </div>
      <div class="content">
        {{ sbi.suggestion }}
      </div>
    </div>
  </div>
</div>
